(() => {
  const DESKTOP_QUERY = '(min-width: 768px)';

  function initProductSliderFeature(section) {
    if (section.dataset.productSliderInitialized === 'true') return;

    const slider = section.querySelector('[data-slider]');
    const nextBtn = section.querySelector('.product-slider-feature__arrow.next');
    const prevBtn = section.querySelector('.product-slider-feature__arrow.prev');
    const navigation = section.querySelector('.product-slider-feature__arrow__wrapper');

    if (!slider) return;

    section.dataset.productSliderInitialized = 'true';

    const desktopMedia = window.matchMedia(DESKTOP_QUERY);
    let currentIndex = 0;
    let touchStartX = 0;
    let touchEndX = 0;
    let isDragging = false;
    let startX = 0;
    let endX = 0;
    let suppressClick = false;
    let wheelDistance = 0;
    let lastWheelTime = 0;
    let lastWheelEventTime = 0;

    const getVisibleSlides = () => (desktopMedia.matches ? 3 : 1);
    const getMaxIndex = () => Math.max(0, slider.children.length - getVisibleSlides());

    const updateSlider = (animate = true) => {
      if (navigation) navigation.style.display = desktopMedia.matches && getMaxIndex() > 0 ? 'flex' : 'none';
      if (!desktopMedia.matches) {
        if (prevBtn) prevBtn.disabled = true;
        if (nextBtn) nextBtn.disabled = true;
        currentIndex = 0;
        slider.style.transition = 'none';
        slider.style.transform = 'none';
        return;
      }

      currentIndex = Math.max(0, Math.min(currentIndex, getMaxIndex()));
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex === getMaxIndex();
      slider.style.transition = animate ? 'transform 0.5s ease' : 'none';
      slider.style.transform = `translateX(-${currentIndex * (100 / getVisibleSlides())}%)`;
    };

    const next = () => {
      if (!desktopMedia.matches) return;

      if (currentIndex < getMaxIndex()) {
        currentIndex += 1;
        updateSlider(true);
        return;
      }
    };

    const prev = () => {
      if (!desktopMedia.matches) return;

      if (currentIndex > 0) {
        currentIndex -= 1;
        updateSlider(true);
        return;
      }
    };

    const handleGesture = () => {
      const swipeThreshold = 50;
      const swipeDistance = touchEndX - touchStartX;

      if (swipeDistance > swipeThreshold) {
        prev();
      } else if (swipeDistance < -swipeThreshold) {
        next();
      }
    };

    slider.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.changedTouches[0].screenX;
      },
      { passive: true }
    );

    slider.addEventListener(
      'touchend',
      (event) => {
        touchEndX = event.changedTouches[0].screenX;
        handleGesture();
      },
      { passive: true }
    );

    slider.addEventListener('mousedown', (event) => {
      if (!desktopMedia.matches || event.button !== 0) return;
      suppressClick = false;
      isDragging = true;
      startX = event.clientX;
      endX = startX;
    });

    slider.addEventListener('mousemove', (event) => {
      if (!isDragging) return;
      endX = event.clientX;
    });

    slider.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;

      const diff = endX - startX;
      const threshold = 50;

      if (diff > threshold) {
        suppressClick = true;
        prev();
      } else if (diff < -threshold) {
        suppressClick = true;
        next();
      }
    });

    slider.addEventListener('mouseleave', () => {
      isDragging = false;
    });

    slider.addEventListener('dragstart', (event) => {
      if (desktopMedia.matches) event.preventDefault();
    });

    slider.addEventListener('click', (event) => {
      if (!desktopMedia.matches || !suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);

    slider.addEventListener('wheel', (event) => {
      if (!desktopMedia.matches || event.ctrlKey) return;
      const delta = event.shiftKey && event.deltaX === 0 ? event.deltaY : event.deltaX;
      if (!delta || (!event.shiftKey && Math.abs(event.deltaY) > Math.abs(delta))) return;
      if ((delta > 0 && currentIndex === getMaxIndex()) || (delta < 0 && currentIndex === 0)) return;

      event.preventDefault();
      const now = Date.now();
      if (now - lastWheelEventTime > 600 || Math.sign(wheelDistance) !== Math.sign(delta)) wheelDistance = 0;
      lastWheelEventTime = now;
      if (now - lastWheelTime < 300) return;
      wheelDistance += delta * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? slider.clientWidth : 1);
      if (Math.abs(wheelDistance) < 40) return;
      if (wheelDistance > 0) next();
      else prev();
      wheelDistance = 0;
      lastWheelTime = now;
    }, { passive: false });

    section.addEventListener('shopify:block:select', (event) => {
      if (!desktopMedia.matches) return;
      const index = Array.from(slider.children).indexOf(event.target.closest('.product-slider-feature__item'));
      if (index < 0) return;
      if (index < currentIndex) currentIndex = index;
      else if (index >= currentIndex + getVisibleSlides()) currentIndex = index - getVisibleSlides() + 1;
      updateSlider();
    });

    nextBtn?.addEventListener('click', next);
    prevBtn?.addEventListener('click', prev);

    desktopMedia.addEventListener?.('change', () => updateSlider(false));
    window.addEventListener('resize', () => updateSlider(false));

    updateSlider(false);
  }

  function initAllProductSliderFeatures() {
    document.querySelectorAll('.product-slider-feature').forEach(initProductSliderFeature);
  }

  document.addEventListener('shopify:section:load', initAllProductSliderFeatures);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllProductSliderFeatures);
  } else {
    initAllProductSliderFeatures();
  }
})();
